export const TransactionSource = {
  VITRIN: 1,
  MINIAPP_DIRECT: 2,
} as const;
export type TransactionSource =
  (typeof TransactionSource)[keyof typeof TransactionSource];

export interface TransactionMiniApp {
  uuid: string;
  title: string;
  username?: string | null;
}

export interface TransactionCourse {
  id: number;
  title: string;
  cover_url: string | null;
}

export interface Transaction {
  reference_key: string;
  course_id: number;
  discount_id: number | null;
  amount: number;
  amount_after_discount: number;
  final_amount: number;
  status: "completed";
  gateway: string | null;
  created_at: string;
  updated_at: string;
  source: TransactionSource;
  mini_app: TransactionMiniApp;
  course: TransactionCourse;
  is_installment: boolean
}
